<!--
component: BrowseBuildingSeko
author: Ken Nakamura
description: 建築計画概要書（第一面 施工者）
-->
<template>
  <section>
    <div v-show="startIndex==0 && endIndex>0" class="gaiyo-row">
      <hr>
      <div class="gaiyo-major-title">
      【6.工事施工者】
      </div>
    </div>
    <div v-for="(seko, index) in sekos" :key="index">
      <div v-show="index>=startIndex && index<endIndex" class="person-block">
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ｲ.氏名】</div>
        <div class="gaiyo-element left-45">{{seko.sekosyA_NAME}}</div>
        <div v-for="(n,index) in wordwrap(seko.sekosyA_NAME,40)" :key="`seko-addr-${index}`">
          <br v-show="index>0"></div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾛ.営業所名】</div>
        <div class="gaiyo-element left-45">建設業の許可（</div>
        <div class="gaiyo-element left-75">&nbsp;{{getRegister(seko.skcP_KYOKA_KKN)}}</div>
        <div class="gaiyo-element left-100">）第&nbsp;{{seko.skcP_KYOKA_NO}}&nbsp;号</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-element left-45">{{seko.skcP_NAME}}</div>
        <div v-for="(n,index) in wordwrap(seko.skcP_NAME,40)" :key="`skcp-name-${index}`">
          <br v-show="index>0"></div>
      <br></div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾊ.郵便番号】</div>
        <div class="gaiyo-element left-45">{{seko.skcP_POSTNO}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾆ.所在地】</div>
        <div class="gaiyo-element left-45">{{seko.skcP_ADDR}}</div>
        <div v-for="(n,index) in wordwrap(seko.skcP_ADDR,40)" :key="`skcp-addr-${index}`">
          <br v-show="index>0"></div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾎ.電話番号】</div>
        <div class="gaiyo-element left-45">{{seko.skcP_TELNO}}</div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
import constants from '../../common/constants'

export default {
  props: {
    sekos: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: () => 0
    },
    endIndex: {
      type: Number,
      default: () => 99
    }
  },
  computed: {
  },
  methods: {
    getShikaku(code) {
      const shikaku = constants.shikakuKubun[code];
      if (shikaku == null) {
        return '';
      }
      else {
        return shikaku.name;
      }
    },
    getRegister(code) {
      const rgst = constants.Register[code];
      if (rgst == null) {
        return '';
      }
      else {
        return rgst.name;
      }
    },
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/gaiyo.css";
</style>